import { PHYSICAL_DR_CONTENT } from "../content";

export interface TrailerDetail {
  routeId?: string | null;
  isPhysicalDrRequired?: boolean;
  trailerId?: string;
  trailerNumber?: string | null;
}

export const hasAnyPhysicalDrNeed = (trailerDetails: TrailerDetail[]): boolean => {
  return trailerDetails.some(
    (trailer) => trailer.routeId && trailer.isPhysicalDrRequired === true
  );
};

export const isTrailerSelected = (trailerDetails: TrailerDetail[]): boolean =>
  trailerDetails.some((trailer) => Boolean(trailer.trailerId));

export interface CheckboxStateOptions {
  isTrailerSelected: boolean;
  isPhysicalDrNeed: boolean;
}

export interface CheckboxState {
  isDisabled: boolean;
  tooltipText: string;
}

export const getCheckboxState = (options: CheckboxStateOptions): CheckboxState => {
  const { dispatchPanel } = PHYSICAL_DR_CONTENT;
  const { isTrailerSelected, isPhysicalDrNeed } = options;
  if (!isTrailerSelected) {
    return {
      isDisabled: true,
      tooltipText: dispatchPanel.tooltipSelectTrailer,
    };
  }

  if (!isPhysicalDrNeed) {
    return {
      isDisabled: true,
      tooltipText: dispatchPanel.tooltipNoPhysicalDrNeed,
    };
  }

  return {
    isDisabled: false,
    tooltipText: "",
  };
};
